<template>
  <div>
    <DxDataGrid
      ref="dataGrid"
      :data-source="europeanChains[0].parametrosPositivos"
      :show-borders="false"
      :show-column-lines="false"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-auto-width="true"
      :show-column-headers="true"
      :show-colon="false"
      :remote-operations="true"
      :hover-state-enabled="false"
      :show-row-lines="false"
      :row-alternation-enabled="false"
      class="custom-grid"
      :no-data-text="$t('noDataText')"
    >
      <DxColumn
        :caption="$t('foodThechnicalInfo.parameter')"
        data-field="Parametro"
      />
      <DxColumn
        :caption="$t('foodThechnicalInfo.result')"
        alignment="center"
        data-field="ResultadoFinal"
        data-type="number"
        :format="{ type: 'fixedPoint', precision: 3 }"
      />

      <DxColumn
        :caption="$t('foodThechnicalInfo.uncertainty')"
        alignment="center"
        data-field="Incertidumbre"
      />
      <DxColumn
        :caption="$t('foodThechnicalInfo.LMR')"
        alignment="center"
        data-field="LMR"
        data-type="number"
        :format="{ type: 'fixedPoint', precision: 2 }"
      />
      <DxColumn
        :caption="$t('foodThechnicalInfo.%LMR')"
        alignment="center"
        data-field="PorcentajeLMR"
      />
      <DxColumn
        :caption="$t('foodThechnicalInfo.Portion')"
        alignment="center"
        data-field="Porcion"
        data-type="number"
        :format="{ type: 'fixedPoint', precision: 0 }"
      />
      <DxColumn
        :caption="$t('foodThechnicalInfo.VariabilityFactor')"
        alignment="center"
        data-field="Variabilidad"
      />
      <DxColumn
        :caption="$t('foodThechnicalInfo.PRP-UL')"
        alignment="center"
        data-field="PRP_UL"
        data-type="number"
        :format="{ type: 'fixedPoint', precision: 2 }"
      />
      <DxColumn
        :caption="$t('foodThechnicalInfo.Intake')"
        alignment="center"
        data-field="Ingesta"
        data-type="number"
        :format="{ type: 'fixedPoint', precision: 2 }"
      />
      <DxColumn
        :caption="$t('foodThechnicalInfo.PRP-UL(%)')"
        alignment="center"
        data-field="PorcentajePRP_UL"
        data-type="number"
        :format="{ type: 'fixedPoint', precision: 2 }"
      />
      <DxColumn
        :caption="$t('foodThechnicalInfo.ARfD')"
        alignment="center"
        data-field="ARFD"
        data-type="number"
        :format="{ type: 'fixedPoint', precision: 2 }"
      />
      <DxColumn
        :caption="$t('foodThechnicalInfo.ARfDAdult')"
        alignment="center"
        data-field="PorcentajeARFDNinos"
        data-type="number"
        :format="{ type: 'fixedPoint', precision: 2 }"
      />
      <DxColumn
        :caption="$t('foodThechnicalInfo.ActiveSubstances')"
        alignment="center"
        data-field="MateriasActivas"
      />
      <DxColumn
        :caption="$t('foodThechnicalInfo.ADI(%)')"
        alignment="center"
        data-field="PorcentajeADI"
        data-type="number"
        :format="{ type: 'fixedPoint', precision: 2 }"
      />
      <DxColumn
        :caption="$t('foodThechnicalInfo.AI')"
        alignment="center"
        data-field="PorcentajeAIMayor25"
        data-type="text"
        :customize-text="formatPorcentajeAIMayor25"
      />
      <DxPager
        :allowed-page-sizes="[5, 10, 15, 20]"
        :show-page-size-selector="true"
        info-text="{2} items"
        :visible="true"
      />
      <DxPaging :page-size="5" />
    </DxDataGrid>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  DxDataGrid,
  DxColumn,
  DxPager,
  DxPaging,
} from 'devextreme-vue/data-grid';
// import { NOTIFY_TIME_LONG } from '@/js/constants';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxPager,
    DxPaging,
  },
  props: {
    store: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loaded: false,
      precioTotal: 0,
      PrecioAT: 0,
    };
  },
  computed: {
    ...mapState('foodSamples', ['europeanChains']),
  },
  methods: {
    formatPorcentajeAIMayor25(e) {
      if (e.value === true) return this.$t('yes');
      if (e.value === false) return this.$t('no');
      return '';
    },
    getGridInstance() {
      return this.$refs.dataGrid?.instance || null;
    },
  },
};
</script>
